import { complaintReasonsFor, reportCategoriesFor } from './occurrence-catalog';
import {
  ClosingType,
  ComplaintReason,
  OccurrenceActionStatus,
  EffectivenessEvaluation,
  IncidentNature,
  IntegratedSystem,
  InterestedParty,
  OccurrenceImpact,
  OccurrenceNature,
  ReporterNature,
  ReporterNatureDetail,
  OccurrenceOrigin,
  OccurrenceOriginDetail,
  OccurrenceOutcome,
  OccurrenceScope,
  OccurrenceSituation,
  OccurrenceState,
  OccurrenceSubScope,
  OccurrenceType,
  OrganizationRelation,
  ParticipantIdentification,
  ProcessArea,
  ReportCategory,
  TriageResult,
  WorkerType,
} from './occurrence.models';

export const SCOPE_LABELS: Record<OccurrenceScope, string> = {
  SISTEMAS_GESTAO: 'Sistemas de Gestão',
  RGPD: 'RGPD',
  RGPC: 'RGPC',
  SEGURANCA_INFORMACAO: 'Segurança da Informação / Cibersegurança',
  OUTRO: 'Outro',
};

export const SUB_SCOPE_LABELS: Record<OccurrenceSubScope, string> = {
  SISTEMA_INTEGRADO: 'Sistema Integrado',
  ISO_9001: 'ISO 9001',
  ISO_56001: 'ISO 56001',
  NP_4590: 'NP 4590',
  OUTRO_SISTEMA: 'Outro sistema',
  EXERCICIO_DIREITOS: 'Pedido de exercício de direitos',
  CONFORMIDADE_PROTECAO_DADOS: 'Conformidade e proteção de dados',
  GESTAO_COMUNICACOES: 'Gestão de comunicações',
  CUMPRIMENTO_NORMATIVO: 'Gestão do cumprimento normativo',
};

export const INTEGRATED_SYSTEM_LABELS: Record<IntegratedSystem, string> = {
  ISO_9001: 'ISO 9001',
  ISO_56001: 'ISO 56001',
  NP_4590: 'NP 4590',
  OUTRO_SISTEMA: 'Outro sistema',
};

export const TYPE_LABELS: Record<OccurrenceType, string> = {
  NAO_CONFORMIDADE: 'Não conformidade (NC)',
  OPORTUNIDADE_MELHORIA: 'Oportunidade de melhoria (OP)',
  ACAO_CORRETIVA: 'Ação corretiva',
  ALTERACAO_SISTEMA: 'Alteração ao sistema',
  PARTICIPACAO_COMUNICACAO: 'Participação / comunicação',
  TRATAMENTO_MONITORIZACAO: 'Tratamento / monitorização',
  ACESSO: 'Acesso',
  RETIFICACAO: 'Retificação',
  APAGAMENTO: 'Apagamento',
  LIMITACAO_TRATAMENTO: 'Limitação do tratamento',
  PORTABILIDADE: 'Portabilidade',
  OPOSICAO: 'Oposição',
  RETIRADA_CONSENTIMENTO: 'Retirada do consentimento',
  NAO_SUJEICAO_DECISAO_AUTOMATIZADA: 'Não sujeição a decisão exclusivamente automatizada',
  OUTRO: 'Outro',
};

export const REPORTER_NATURE_LABELS: Record<ReporterNature, string> = {
  BEM_ESTAR_CONDICOES_TRABALHO: 'Bem-Estar e condições de trabalho',
  ETICA_INTEGRIDADE_CONDUTA: 'Ética, integridade e conduta',
  SEGURANCA_INFORMACAO: 'Segurança da informação/Cibersegurança',
  PROTECAO_DADOS: 'Proteção de dados pessoais (RGPD)',
  OUTRAS_INFRACOES: 'Outras infrações e irregularidades',
};

export const REPORTER_NATURE_DETAIL_LABELS: Record<ReporterNatureDetail, string> = {
  DEFESA_CONSUMIDOR: 'Defesa do consumidor e incumprimento legal ou regulamentar de produtos e serviços',
  CONTRATACAO_PUBLICA_CONCORRENCIA: 'Contratação pública e concorrência',
  PROTECAO_AMBIENTE: 'Proteção do ambiente',
  OUTRA_IRREGULARIDADE: 'Outra irregularidade',
};

export const NATURE_LABELS: Record<OccurrenceNature, string> = {
  RECLAMACAO: 'Reclamação',
  DENUNCIA: 'Denúncia',
  SUGESTAO_IDEIA: 'Sugestões / ideias',
  ELOGIO_RECONHECIMENTO: 'Elogios / reconhecimentos',
};

export const IMPACT_LABELS: Record<OccurrenceImpact, string> = {
  BAIXO: 'Baixo',
  MODERADO: 'Moderado',
  ALTO: 'Alto',
  NAO_APLICAVEL: 'Não aplicável',
  NAO_IDENTIFICADO: 'Não identificado',
};

export const PROCESS_AREA_LABELS: Record<ProcessArea, string> = {
  RECRUITMENT_TALENT: 'Recruitment & Talent',
  QUALITY_ASSURANCE_GOVERNANCE: 'Quality Assurance & Governance',
  SOLUTIONS_INNOVATION: 'Solutions & Innovation',
  BUSINESS: 'Business',
  OPERACIONAL: 'Operacional',
  FINANCEIRO: 'Financeiro',
  INFRAESTRUTURA: 'Infraestrutura',
  ORGANIZACAO_TRANSVERSAL: 'Organização / Transversal',
  NAO_APLICAVEL: 'Não aplicável / não identificado',
  OUTRO: 'Outro',
};

export const COMPLAINT_REASON_LABELS: Record<ComplaintReason, string> = {
  PRODUTO_SERVICO: 'Produto ou serviço',
  ATENDIMENTO_COMUNICACAO: 'Atendimento ou comunicação',
  CONDICOES_TRABALHO_BEM_ESTAR: 'Condições de trabalho e bem-estar',
  OUTRO: 'Outro',
};

export const REPORT_CATEGORY_LABELS: Record<ReportCategory, string> = {
  CORRUPCAO_FRAUDE: 'Corrupção, fraude e infrações conexas',
  CONFLITO_INTERESSES: 'Conflito de interesses',
  VIOLACAO_CODIGO_CONDUTA: 'Violação do Código de Conduta, políticas ou procedimentos internos',
  ASSEDIO_DISCRIMINACAO: 'Assédio, discriminação, abuso ou outras condutas impróprias',
  VIOLACAO_LEGAL_REGULAMENTAR: 'Violação legal, regulamentar ou de regras de mercado',
  BRANQUEAMENTO_CAPITAIS: 'Branqueamento de capitais, financiamento do terrorismo ou criminalidade organizada',
  SEGURANCA_INFORMACAO: 'Segurança da informação',
  ACESSO_UTILIZACAO_INDEVIDA_DADOS: 'Acesso ou utilização indevida de dados',
  DIVULGACAO_PARTILHA_NAO_AUTORIZADA: 'Divulgação ou partilha não autorizada',
  FALHA_SEGURANCA_CONFIDENCIALIDADE: 'Falha de segurança ou confidencialidade',
  BEM_ESTAR_ORGANIZACIONAL: 'Bem-estar organizacional e ambiente de trabalho',
  CARGA_TRABALHO: 'Carga de trabalho',
  CONCILIACAO_VIDA_PROFISSIONAL_PESSOAL: 'Conciliação entre a vida profissional e pessoal',
  SEGURANCA_SAUDE: 'Segurança e saúde',
  PROTECAO_AMBIENTE: 'Proteção do ambiente',
  CONTRATACAO_PUBLICA_CONCORRENCIA: 'Contratação pública e concorrência',
  DEFESA_CONSUMIDOR: 'Defesa do consumidor e incumprimento legal ou regulamentar de produtos e serviços',
  OUTRA_IRREGULARIDADE: 'Outra irregularidade',
};

export const ORGANIZATION_RELATION_LABELS: Record<OrganizationRelation, string> = {
  CANDIDATO: 'Candidato',
  COLABORADOR: 'Colaborador',
  DIRECAO_RESPONSAVEL: 'Direção / responsável',
  CLIENTE: 'Cliente',
  FORNECEDOR_PARCEIRO: 'Fornecedor / parceiro',
  ENTIDADE_EXTERNA: 'Entidade externa',
  OUTRA_PARTE_INTERESSADA: 'Outra parte interessada',
};

export const WORKER_TYPE_LABELS: Record<WorkerType, string> = {
  INTERNO: 'Interno',
  CONSULTOR_CPS: 'Consultor CPS',
  CONSULTOR_CST: 'Consultor CST',
  CONSULTOR_CTI: 'Consultor CTI',
};

export const INTERESTED_PARTY_LABELS: Record<InterestedParty, string> = {
  CLIENTES: 'Clientes',
  COLABORADORES: 'Colaboradores',
  OUTRAS_PARTES_INTERESSADAS: 'Outras partes interessadas',
};

export const ORIGIN_LABELS: Record<OccurrenceOrigin, string> = {
  SITE: 'Site',
  ESSENTIALS: 'Essentials',
  EMAIL: 'E-mail',
  REUNIAO_GESTAO: 'Reunião de gestão',
  LIVRO_RECLAMACOES: 'Livro de Reclamações',
  AUSCULTACAO: 'Auscultação',
  REUNIAO: 'Reuniões operacionais ou contacto direto',
  COLABORADOR: 'Colaborador',
  CLIENTE: 'Cliente',
  OUTRAS_PARTES_INTERESSADAS: 'Outras partes interessadas',
  AUDITORIA: 'Auditorias',
  AVALIACAO_MONITORIZACAO: 'Monitorização / avaliação',
  REVISAO_SISTEMA: 'Revisão do sistema',
  SESSOES_TRABALHO: 'Sessões de trabalho',
  BOAS_PRATICAS: 'Boas práticas',
  ATIVIDADE_OPERACIONAL: 'Atividade operacional',
  AUTORIDADE_EXTERNA: 'Autoridade ou entidade externa',
  DECORRENTE_OUTRA_OCORRENCIA: 'Decorrente de outra ocorrência',
  CONTEXTO_DECISAO_ESTRATEGICA: 'Contexto / decisão estratégica',
  OCORRENCIA_IRREGULARIDADE: 'Ocorrência / irregularidade',
  ALTERACAO_ORGANIZACIONAL: 'Alteração organizacional / operacional',
  NECESSIDADES_PARTES_INTERESSADAS: 'Necessidades e requisitos das partes interessadas',
  REQUISITO_LEGAL: 'Requisito legal / regulamentar / normativo',
  OUTRA_ORIGEM: 'Outra',
};

export const ORIGIN_DETAIL_LABELS: Record<OccurrenceOriginDetail, string> = {
  REUNIAO_GESTAO: 'De gestão',
  REUNIAO_EQUIPA: 'De equipa',
  OUTRA_REUNIAO: 'Outra',
  COLABORADOR_INTERNO: 'Interno',
  CONSULTOR_CPS: 'Consultor CPS',
  CONSULTOR_CST_CTI: 'Consultor CST/CTI',
  RISCO: 'Risco',
  OPORTUNIDADE: 'Oportunidade',
  OBJETIVOS_INDICADORES: 'Objetivos / indicadores',
  ACOMPANHAMENTO_ACOES_ANTERIORES: 'Acompanhamento de ações anteriores',
  SATISFACAO: 'Satisfação',
  MONITORIZACAO_SISTEMA: 'Monitorização do Sistema',
  ACAO_RESPOSTA_OCORRENCIA: 'Ação de resposta a outra ocorrência',
  AVALIACAO_EFICACIA: 'Avaliação da eficácia',
  AVALIACAO_FORNECEDORES: 'Avaliação de desempenho de fornecedores',
  AVALIACAO_SATISFACAO_CLIENTES: 'Avaliação da satisfação dos clientes',
  AVALIACAO_SATISFACAO_COLABORADOR: 'Avaliação da satisfação do colaborador',
  DPIA: 'Avaliação de Impacto sobre a Proteção de Dados — DPIA',
  REVISAO_RAT: 'Revisão do Registo das Atividades de Tratamento — RAT',
  REVISAO_PPR: 'Revisão do Plano de Prevenção de Riscos — PPR',
  AUDITORIA_INTERNA: 'Interna',
  AUDITORIA_EXTERNA: 'Externa',
  OUTRA_AUDITORIA: 'Outra',
  // Siglas por extenso: quem preenche não tem de as decorar.
  CNPD: 'Comissão Nacional de Proteção de Dados — CNPD',
  MENAC: 'Mecanismo Nacional Anticorrupção — MENAC',
  OUTRA_AUTORIDADE: 'Outra',
};

export const PARTICIPANT_LABELS: Record<ParticipantIdentification, string> = {
  ANONIMO: 'Anónimo',
  IDENTIFICADO: 'Identificado',
};

export const INCIDENT_NATURE_LABELS: Record<IncidentNature, string> = {
  ACESSO_NAO_AUTORIZADO: 'Acesso não autorizado',
  DIVULGACAO_NAO_AUTORIZADA: 'Divulgação não autorizada',
  ALTERACAO_INDEVIDA: 'Alteração indevida',
  PERDA_INDISPONIBILIDADE: 'Perda ou indisponibilidade',
  DESTRUICAO: 'Destruição',
  OUTRO: 'Outro',
};

export const SITUATION_LABELS: Record<OccurrenceSituation, string> = {
  ABERTO: 'Aberto',
  FECHADO: 'Fechado',
};

export const STATE_LABELS: Record<OccurrenceState, string> = {
  REGISTADO: 'Registado',
  EM_ANALISE: 'Em análise',
  EM_TRATAMENTO: 'Em tratamento',
  EM_MONITORIZACAO: 'Em seguimento',
  AVALIACAO_REAVALIACAO: 'Em avaliação',
};

export const CLOSING_TYPE_LABELS: Record<ClosingType, string> = {
  COM_SUCESSO: 'Com sucesso',
  SEM_SUCESSO: 'Sem sucesso',
  /** Fechada na triagem, sem chegar a ser tratada (documento de 2026-10-03). */
  FECHADO_APOS_ANALISE: 'Fechado após análise',
  /**
   * Fechada com a verificação da eficácia por fazer — faz-se uns seis meses depois (revisão de
   * 2026-10-12). É o fecho proposto quando a verificação é aplicável.
   */
  SUJEITO_VERIFICACAO: 'Sujeito a verificação',
};

export const TRIAGE_RESULT_LABELS: Record<TriageResult, string> = {
  ACEITE: 'Aceite',
  NAO_ACEITE: 'Não aceite',
};

export const OUTCOME_LABELS: Record<OccurrenceOutcome, string> = {
  COM_MEDIDAS_ADOTADAS: 'Com medidas adotadas',
  SEM_FACTOS_CONFIRMADOS: 'Sem factos confirmados',
  NAO_ACEITE_NESTE_CANAL: 'Não aceite neste canal',
  ENCERRADO_FALTA_ELEMENTOS: 'Encerrado por falta de elementos',
  SEM_ENQUADRAMENTO: 'Sem enquadramento',
  DUPLICADO: 'Duplicado',
  ENCAMINHADO: 'Encaminhado',
  OUTRO: 'Outro',
};

/**
 * Norma a que cada motivo de reclamação pertence. Fica ao lado do motivo na escolha — quem
 * regista precisa de saber que "condições de trabalho" é NP 4590 e não ISO 9001 — mas fora do
 * rótulo, para que o motivo apareça limpo quando é só para ler.
 */
export const COMPLAINT_REASON_NORMS: Record<ComplaintReason, string | null> = {
  PRODUTO_SERVICO: 'ISO 9001',
  ATENDIMENTO_COMUNICACAO: 'Transversal',
  CONDICOES_TRABALHO_BEM_ESTAR: 'NP 4590',
  OUTRO: null,
};

/**
 * Aviso sobre dados de saúde. Aparece quando a comunicação toca assédio, segurança e saúde ou
 * condições de trabalho — as situações em que quem escreve tende a juntar informação clínica
 * que não é precisa para tratar o caso.
 */
export const HEALTH_DATA_NOTE =
  'Não é necessário incluir dados de saúde na comunicação para que a mesma seja analisada e '
  + 'tratada. Caso o Utilizador opte por os incluir, serão tratados de forma confidencial e com '
  + 'acesso restrito. Este canal não substitui a avaliação de riscos psicossociais no âmbito da '
  + 'segurança e saúde no trabalho.';

/** Categorias de denúncia que fazem aparecer o aviso dos dados de saúde. */
export const HEALTH_DATA_CATEGORIES: readonly ReportCategory[] = [
  'ASSEDIO_DISCRIMINACAO', 'SEGURANCA_SAUDE',
];

/** Motivo de reclamação que faz aparecer o mesmo aviso. */
export const HEALTH_DATA_COMPLAINT_REASON: ComplaintReason = 'CONDICOES_TRABALHO_BEM_ESTAR';

export const EFFECTIVENESS_LABELS: Record<EffectivenessEvaluation, string> = {
  NAO_APLICAVEL: 'Não aplicável',
  EFICAZ: 'Eficaz',
  NAO_EFICAZ: 'Não eficaz',
  NAO_FOI_POSSIVEL_AFERIR: 'Não foi possível de aferir',
};

/* ---------------------------------------------------------------------------
   Ícones Feather por valor — assinatura visual de cada coisa (menos texto
   para ler, reconhecimento imediato). Usados no detalhe e na lista.
   --------------------------------------------------------------------------- */
export const SCOPE_ICONS: Record<OccurrenceScope, string> = {
  SISTEMAS_GESTAO: 'fe-layers',
  RGPD: 'fe-lock',
  RGPC: 'fe-shield',
  SEGURANCA_INFORMACAO: 'fe-wifi-off',
  OUTRO: 'fe-help-circle',
};

export const TYPE_ICONS: Record<OccurrenceType, string> = {
  NAO_CONFORMIDADE: 'fe-alert-circle',
  OPORTUNIDADE_MELHORIA: 'fe-trending-up',
  ACAO_CORRETIVA: 'fe-target',
  ALTERACAO_SISTEMA: 'fe-refresh-cw',
  PARTICIPACAO_COMUNICACAO: 'fe-message-square',
  TRATAMENTO_MONITORIZACAO: 'fe-activity',
  ACESSO: 'fe-eye',
  RETIFICACAO: 'fe-edit-2',
  APAGAMENTO: 'fe-trash-2',
  LIMITACAO_TRATAMENTO: 'fe-pause-circle',
  PORTABILIDADE: 'fe-share',
  OPOSICAO: 'fe-slash',
  RETIRADA_CONSENTIMENTO: 'fe-user-x',
  NAO_SUJEICAO_DECISAO_AUTOMATIZADA: 'fe-cpu',
  OUTRO: 'fe-tag',
};

/** Cada natureza tem assinatura própria: a lista distingue-as sem ler o rótulo. */
export const NATURE_ICONS: Record<OccurrenceNature, string> = {
  RECLAMACAO: 'fe-thumbs-down',
  DENUNCIA: 'fe-alert-octagon',
  SUGESTAO_IDEIA: 'fe-zap',
  ELOGIO_RECONHECIMENTO: 'fe-thumbs-up',
};

export const ORIGIN_ICONS: Record<OccurrenceOrigin, string> = {
  SITE: 'fe-globe',
  ESSENTIALS: 'fe-grid',
  EMAIL: 'fe-mail',
  REUNIAO_GESTAO: 'fe-users',
  LIVRO_RECLAMACOES: 'fe-book',
  AUSCULTACAO: 'fe-mic',
  REUNIAO: 'fe-users',
  COLABORADOR: 'fe-user',
  CLIENTE: 'fe-user-check',
  OUTRAS_PARTES_INTERESSADAS: 'fe-share-2',
  AUDITORIA: 'fe-clipboard',
  AVALIACAO_MONITORIZACAO: 'fe-bar-chart-2',
  REVISAO_SISTEMA: 'fe-repeat',
  SESSOES_TRABALHO: 'fe-coffee',
  BOAS_PRATICAS: 'fe-award',
  ATIVIDADE_OPERACIONAL: 'fe-settings',
  AUTORIDADE_EXTERNA: 'fe-shield',
  DECORRENTE_OUTRA_OCORRENCIA: 'fe-link',
  CONTEXTO_DECISAO_ESTRATEGICA: 'fe-compass',
  OCORRENCIA_IRREGULARIDADE: 'fe-alert-triangle',
  ALTERACAO_ORGANIZACIONAL: 'fe-git-branch',
  NECESSIDADES_PARTES_INTERESSADAS: 'fe-users',
  REQUISITO_LEGAL: 'fe-book-open',
  OUTRA_ORIGEM: 'fe-more-horizontal',
};

export const PARTICIPANT_ICONS: Record<ParticipantIdentification, string> = {
  ANONIMO: 'fe-eye-off',
  IDENTIFICADO: 'fe-user-check',
};

/** Ordena por rótulo (pt-BR, acentos colam corretamente); "Outro/Outra" sempre por último. */
const byLabel = (a: { value: string; label: string }, b: { value: string; label: string }) => {
  if (a.value === 'OUTRA' || a.value === 'OUTRO') return 1;
  if (b.value === 'OUTRA' || b.value === 'OUTRO') return -1;
  return a.label.localeCompare(b.label, 'pt-BR');
};

export const SCOPE_OPTIONS =
  (['SISTEMAS_GESTAO', 'RGPD', 'RGPC', 'SEGURANCA_INFORMACAO', 'OUTRO'] as OccurrenceScope[])
    .map((value) => ({ value, label: SCOPE_LABELS[value] }));
export const TYPE_OPTIONS = (Object.keys(TYPE_LABELS) as OccurrenceType[])
  .map((value) => ({ value, label: TYPE_LABELS[value] }))
  .sort(byLabel);
/** Todas as origens — o filtro da lista mostra-as todas; o formulário usa originsFor. */
export const ORIGIN_OPTIONS = (Object.keys(ORIGIN_LABELS) as OccurrenceOrigin[])
  .map((value) => ({ value, label: ORIGIN_LABELS[value] }));

export const PARTICIPANT_OPTIONS = (['ANONIMO', 'IDENTIFICADO'] as ParticipantIdentification[])
  .map((value) => ({ value, label: PARTICIPANT_LABELS[value] }));

/** Ordem do documento (não alfabética) — a natureza é uma escala, não uma lista qualquer. */
export const NATURE_OPTIONS = (Object.keys(NATURE_LABELS) as OccurrenceNature[])
  .map((value) => ({ value, label: NATURE_LABELS[value] }));

export const IMPACT_OPTIONS = (Object.keys(IMPACT_LABELS) as OccurrenceImpact[])
  .map((value) => ({ value, label: IMPACT_LABELS[value] }));

export const PROCESS_AREA_OPTIONS = (Object.keys(PROCESS_AREA_LABELS) as ProcessArea[])
  .map((value) => ({ value, label: PROCESS_AREA_LABELS[value] }));

export const TRIAGE_RESULT_OPTIONS = (Object.keys(TRIAGE_RESULT_LABELS) as TriageResult[])
  .map((value) => ({ value, label: TRIAGE_RESULT_LABELS[value] }));

export const OUTCOME_OPTIONS = (Object.keys(OUTCOME_LABELS) as OccurrenceOutcome[])
  .map((value) => ({ value, label: OUTCOME_LABELS[value] }));

/**
 * Tipos de fecho para escolher. Vem dos rótulos e não de uma lista escrita à mão em cada ecrã:
 * o "fechado após análise" de 2026-10-03 entrou nos rótulos e não apareceu em nenhum dos dois
 * sítios onde as opções estavam copiadas.
 */
export const CLOSING_TYPE_OPTIONS = (Object.keys(CLOSING_TYPE_LABELS) as ClosingType[])
  .map((value) => ({ value, label: CLOSING_TYPE_LABELS[value] }));

/**
 * Prazos legais próprios (documento de 2026-09-26). Não são campos nem geram alertas — o
 * documento deixa as colunas de alerta por preencher, e dois dias de antecedência não serviriam
 * a prazos contados em horas. Ficam à vista de quem trata o caso, com a regra de precedência à
 * cabeça: quando um destes é mais curto, é ele que manda.
 */
export const LEGAL_DEADLINES: readonly { situation: string; deadline: string; note?: string }[] = [
  {
    situation: 'Possível violação de dados pessoais',
    deadline: 'de imediato, no máximo 24 horas',
    note: 'perda, acesso indevido, envio errado, exposição ou suspeita',
  },
  {
    situation: 'Notificação à autoridade de controlo',
    deadline: '72 horas',
    note: 'quando aplicável, nos termos do artigo 33.º do RGPD',
  },
  { situation: 'Procedimento disciplinar em matéria de assédio', deadline: '60 dias' },
  { situation: 'Comunicação de acidente de trabalho mortal ou grave', deadline: '24 horas' },
];

/**
 * Opções do motivo da reclamação para um subâmbito. O motivo leva a norma atrás quando o
 * subâmbito ainda não a determina (sistema integrado, outro sistema): é o que diz a quem regista
 * onde o caso vai cair.
 */
export function complaintReasonOptions(
  subScope: OccurrenceSubScope | null,
): readonly { value: ComplaintReason; label: string }[] {
  const reasons = complaintReasonsFor(subScope);
  const showNorm = subScope !== 'NP_4590' && subScope !== 'ISO_9001';
  return reasons.map((value) => ({
    value,
    label: showNorm && COMPLAINT_REASON_NORMS[value]
      ? `${COMPLAINT_REASON_LABELS[value]} (${COMPLAINT_REASON_NORMS[value]})`
      : COMPLAINT_REASON_LABELS[value],
  }));
}

/**
 * Opções da denúncia para um âmbito. Deixou de haver uma lista só: desde o documento de
 * 2026-10-01 o RGPD tem a sua (ver `reportCategoriesFor` no catálogo).
 */
export function reportCategoryOptions(
  scope: OccurrenceScope | null,
): readonly { value: ReportCategory; label: string }[] {
  return reportCategoriesFor(scope).map((value) => ({ value, label: REPORT_CATEGORY_LABELS[value] }));
}

export const ORGANIZATION_RELATION_OPTIONS = (Object.keys(ORGANIZATION_RELATION_LABELS) as OrganizationRelation[])
  .map((value) => ({ value, label: ORGANIZATION_RELATION_LABELS[value] }));

export const WORKER_TYPE_OPTIONS = (Object.keys(WORKER_TYPE_LABELS) as WorkerType[])
  .map((value) => ({ value, label: WORKER_TYPE_LABELS[value] }));

export const INTERESTED_PARTY_OPTIONS = (Object.keys(INTERESTED_PARTY_LABELS) as InterestedParty[])
  .map((value) => ({ value, label: INTERESTED_PARTY_LABELS[value] }));

export const INCIDENT_NATURE_OPTIONS = (Object.keys(INCIDENT_NATURE_LABELS) as IncidentNature[])
  .map((value) => ({ value, label: INCIDENT_NATURE_LABELS[value] }));
/**
 * Ordem do ciclo de vida (não alfabética): é a sequência do stepper e também a que decide que
 * secções o estado torna obrigatórias — espelha o ValidateOccurrenceStateRequirementsService.
 */
export const STATE_ORDER: OccurrenceState[] = [
  'REGISTADO', 'EM_ANALISE', 'EM_TRATAMENTO', 'EM_MONITORIZACAO', 'AVALIACAO_REAVALIACAO',
];

export const STATE_OPTIONS = STATE_ORDER.map((value) => ({ value, label: STATE_LABELS[value] }));

/**
 * O nome do botão que põe a ocorrência em cada estado (documento de 2026-10-06).
 *
 * <p>Cada secção tem o seu: a Análise oferece "Iniciar análise", o Tratamento "Iniciar
 * tratamento". Registado não tem — é onde a ocorrência nasce, e não se volta lá.
 */
export const START_LABELS: Partial<Record<OccurrenceState, string>> = {
  EM_ANALISE: 'Iniciar análise',
  EM_TRATAMENTO: 'Iniciar tratamento',
  EM_MONITORIZACAO: 'Iniciar seguimento',
  AVALIACAO_REAVALIACAO: 'Iniciar avaliação',
};

export const SITUATION_OPTIONS = (['ABERTO', 'FECHADO'] as OccurrenceSituation[])
  .map((value) => ({ value, label: SITUATION_LABELS[value] }));

/** O que a badge de estado precisa de ler — serve a ocorrência e as ligações. */
export interface StateBadgeSource {
  readonly situation: OccurrenceSituation;
  readonly state: OccurrenceState;
  readonly closingType: ClosingType | null;
}

/**
 * Cor da badge: fechada fala do desfecho (verde/vermelho), aberta fala do ponto do ciclo.
 * Vive aqui porque a lista, o detalhe e as ligações mostram a mesma badge.
 */
export function stateBadgeClass(item: StateBadgeSource): string {
  if (item.situation === 'FECHADO') {
    return item.closingType === 'SEM_SUCESSO' ? 'bg-danger-soft' : 'bg-success-soft';
  }
  switch (item.state) {
    case 'AVALIACAO_REAVALIACAO': return 'bg-warning-soft';
    case 'EM_MONITORIZACAO': return 'bg-secondary-soft';
    case 'EM_TRATAMENTO': return 'bg-primary-soft';
    case 'EM_ANALISE': return 'bg-info-soft';
    default: return 'bg-dark-soft';
  }
}

export function stateBadgeLabel(item: StateBadgeSource): string {
  if (item.situation === 'FECHADO') {
    return item.closingType
      ? `${SITUATION_LABELS.FECHADO} · ${CLOSING_TYPE_LABELS[item.closingType]}`
      : SITUATION_LABELS.FECHADO;
  }
  return STATE_LABELS[item.state];
}

/** Campos auditados no histórico de reclassificações. */
export const AUDIT_FIELD_LABELS: Record<string, string> = {
  scope: 'Âmbito',
  subScope: 'Subâmbito',
  integratedSystems: 'Sistemas aplicáveis',
  type: 'Tipo',
  origin: 'Origem',
  originDetail: 'Detalhe da origem',
  nature: 'Natureza',
  processArea: 'Processo / área',
  participantIdentification: 'Participante',
  state: 'Estado',
  situation: 'Situação',
  closingType: 'Tipo de fecho',
  outcome: 'Desfecho',
  /** A mãe foi eliminada e esta ficou sem ligação (revisão de 2026-10-15) — guarda-se o código. */
  parentId: 'Ocorrência de origem (eliminada)',
};

/**
 * Tipos de tratamento reservado: denúncias e afins seguem circuito confidencial e não podem
 * ler-se na lista como uma oportunidade de melhoria qualquer.
 */
export function isSensitiveType(nature: OccurrenceNature | null): boolean {
  return nature === 'DENUNCIA';
}

/** Detalhes "Outra/Outro" que abrem o campo de texto da origem. */
export const ORIGIN_DETAILS_WITH_OTHER: OccurrenceOriginDetail[] =
  ['OUTRA_REUNIAO', 'OUTRA_AUDITORIA', 'OUTRA_AUTORIDADE'];

/** Origens que abrem o campo de texto por si (a lista acabou em "Outra"). */
export const ORIGINS_WITH_OTHER: OccurrenceOrigin[] = ['OUTRA_ORIGEM'];

/** Categorias cujo campo de texto identifica QUEM (desabilitado com participante anónimo). */
export const ORIGINS_WITH_WHO: OccurrenceOrigin[] = ['CLIENTE', 'OUTRAS_PARTES_INTERESSADAS'];

/** O estado das ações do tratamento, como a revisão de 2026-10-19 o escreve. */
export const ACTION_STATUS_LABELS: Record<OccurrenceActionStatus, string> = {
  REGISTADA: 'Registado',
  EM_SEGUIMENTO: 'Em seguimento',
  PENDENTE: 'Pendente',
  FECHADA: 'Fechado',
};

export const ACTION_STATUS_OPTIONS: readonly { value: OccurrenceActionStatus; label: string }[] =
  (Object.keys(ACTION_STATUS_LABELS) as OccurrenceActionStatus[])
    .map((value) => ({ value, label: ACTION_STATUS_LABELS[value] }));

/** Cor do estado da ação na tabela: o que está parado chama a atenção, o fechado apaga-se. */
export const ACTION_STATUS_CLASS: Record<OccurrenceActionStatus, string> = {
  REGISTADA: 'bg-secondary-soft',
  EM_SEGUIMENTO: 'bg-primary-soft',
  PENDENTE: 'bg-warning-soft',
  FECHADA: 'bg-success-soft',
};
